/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
import React, { Component } from 'react';
import { CodeSnippet as CarbonCodeSnippet } from 'carbon-components-react';
import stringResource from '../nls/StringResource';

export default class CodeSnippet extends Component<any, any> {
	_input: HTMLTextAreaElement;
	_copyHandler = () => {
		if (this.props.onClick) {
			this.props.onClick();
		}

		const textArea = this._input;
		const isiOSDevice = navigator.userAgent.match(/ipad|iphone/i);
		if (isiOSDevice) {
			const editable = textArea.contentEditable;
			const { readOnly } = textArea;
			textArea.contentEditable = 'true';
			textArea.readOnly = false;
			const range = document.createRange();
			range.selectNodeContents(textArea);
			const selection = window.getSelection();
			selection.removeAllRanges();
			selection.addRange(range);
			textArea.setSelectionRange(0, 999999);
			textArea.contentEditable = editable;
			textArea.readOnly = readOnly;
		} else {
			textArea.select();
		}
		document.execCommand && document.execCommand('Copy');
	};

	render() {
		return (
			<>
				<CarbonCodeSnippet
					{...this.props}
					onClick={this._copyHandler}
					copyLabel={stringResource.get('copyText')}
					ariaLabel={stringResource.get('copyText')}
					feedback={stringResource.get('copied')}
					showMoreText={stringResource.get('ShowMore')}
					showLessText={stringResource.get('ShowLess')}
					copyButtonDescription={stringResource.get('copy')}
				/>
				<textarea
					style={{
						position: 'absolute',
						top: 0,
						opacity: 0,
						zIndex: -1,
					}}
					ref={r => (this._input = r)}
					readOnly
					tabIndex={-1}
					value={this.props.children as string}
				/>
			</>
		);
	}
}
